import { Box, CircularProgress, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import LinkConstants from "../../../../../constants/LinkConstants";
import styles from "./OverviewCard.module.scss";

type Props = {
	icon: string;
	title: string;
	description: string;
	link: LinkConstants;
	newTab?: boolean;
	onClick?: React.MouseEventHandler<HTMLAnchorElement>;
	loading?: boolean;
};

const OverviewCard = ({ icon, title, description, link, newTab, onClick, loading }: Props) => {
	return (
		<NavLink
			className={styles.card}
			to={link}
			target={newTab ? "_blank" : undefined}
			onClick={onClick}
			aria-disabled={loading}
		>
			{loading ? (
				<CircularProgress color="inherit" className={styles.loader} />
			) : (
				<img className={styles.icon} src={icon} />
			)}
			<Box className={styles.texts}>
				<Typography className={styles.title}>{title}</Typography>
				<Typography className={styles.description}>{description}</Typography>
			</Box>
		</NavLink>
	);
};

export default OverviewCard;
